<template>
  <button type="button" @click="onClick">
    <i class="ic ic-help"></i>
    <span class="hide-access">{{ Translator('soprasolar.project.help') }}</span>
  </button>
</template>
<style scoped lang="scss">
@import "~@/soprasolar-project/assets/styles/import";
button {
  @include resetBtn;
  font-size: rem(22);
  width: rem(25);
  height: rem(25);
  color: $grey;
  margin: rem(-3) rem(3) rem(3);
}
</style>
<script>
import AppControlService from '@/soprasolar-project/services/AppControl';

export default {
  name: 'help',
  props: ['image'],
  mounted() {},

  methods: {
    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    onClick() {
      AppControlService.popinHelpToggle(true, this.image);
    }
  }
};
</script>
